import React from 'react';
import {ErrorNotFound} from '../../features/Errors';
import Home from '../../features/Home';
import {SchoolsListContainer, SchoolDetailsContainer} from '../../features/Schools';
import EventsContainer, {EventDetailsContainer} from '../../features/Events';
import ContactContainer from '../../features/Contact';
import AboutContainer from '../../features/About';
import PageContainer, {PageMenu} from '../../features/Content';
import {ConfirmEmailAddressContainer, SetNewPasswordContainer} from '../../features/Auth';
import {DashboardProfileContainer, DashboardEventsContainer, DashboardSchoolsContainer, DashboardSchoolDetailsContainer} from '../../features/Dashboard';
import NewsListContainer, {NewsDetailsContainer} from '../../features/News';
import InstitutionsListContainer, {InstitutionsDetailsContainer} from '../../features/Institutions';

/**
 * Defines the routes of the application.
 *
 * NB: the "sidebar" property could be either a translation key or a React Component, @see HeaderNavigation
 * sidebar: 'header_navigation.foo',
 * sidebar: () => <span>Foo</span>,
 */

const routesFr = [
    {
        path: "/contact",
        exact: true,
        sidebar: 'header_navigation.contact',
        main: ContactContainer
    },
    {
        path: "/a-propos",
        exact: true,
        sidebar: 'header_navigation.apropos',
        main: AboutContainer
    },
    {
        path: "/ecoles",
        exact: true,
        sidebar: 'header_navigation.annuaire_ecoles',
        main: SchoolsListContainer
    },
    {
        path: "/ecoles/:slug",
        exact: true,
        sidebar: 'header_navigation.annuaire_ecoles',
        main: SchoolDetailsContainer
    },
    {
        path: "/evenements",
        exact: true,
        sidebar: 'header_navigation.culturel',
        main: EventsContainer
    },
    {
        path: "/evenements/:slug",
        exact: true,
        sidebar: 'header_navigation.culturel',
        main: EventDetailsContainer
    },
    {
        path: "/page/:slug",
        exact: true,
        sidebar: PageMenu,
        main: PageContainer
    },
    {
        path: "/actualites",
        exact: true,
        sidebar: 'header_navigation.actualites',
        main: NewsListContainer
    },
    {
        path: "/actualites/:slug",
        exact: true,
        sidebar: 'header_navigation.actualites',
        main: NewsDetailsContainer
    },
    {
        path: "/institutions",
        exact: true,
        sidebar: 'header_navigation.institutions',
        main: InstitutionsListContainer
    },
    {
        path: "/institutions/:slug",
        exact: true,
        sidebar: 'header_navigation.institutions',
        main: InstitutionsDetailsContainer
    }

];

const routesEn = [
    {
        path: "/en/contact",
        exact: true,
        sidebar: 'header_navigation.contact',
        main: ContactContainer
    },
    {
        path: "/en/about",
        exact: true,
        sidebar: 'header_navigation.apropos',
        main: AboutContainer
    },
    {
        path: "/en/schools",
        exact: true,
        sidebar: 'header_navigation.annuaire_ecoles',
        main: SchoolsListContainer
    },
    {
        path: "/en/schools/:slug",
        exact: true,
        sidebar: 'header_navigation.annuaire_ecoles',
        main: SchoolDetailsContainer
    },
    {
        path: "/en/events",
        exact: true,
        sidebar: 'header_navigation.culturel',
        main: EventsContainer
    },
    {
        path: "/en/events/:slug",
        exact: true,
        sidebar: 'header_navigation.culturel',
        main: EventDetailsContainer
    },
    {
        path: "/en/page/:slug",
        exact: true,
        sidebar: PageMenu,
        main: PageContainer
    },
    {
        path: "/en/news",
        exact: true,
        sidebar: 'header_navigation.actualites',
        main: NewsListContainer
    },
    {
        path: "/en/news/:slug",
        exact: true,
        sidebar: 'header_navigation.actualites',
        main: NewsDetailsContainer
    },
    {
        path: "/institutions",
        exact: true,
        sidebar: 'header_navigation.institutions',
        main: InstitutionsListContainer
    },
    {
        path: "/institutions/:slug",
        exact: true,
        sidebar: 'header_navigation.institutions',
        main: InstitutionsDetailsContainer
    }
];

const routesGlobal = [
    {
        path: "/dashboard/profile",
        exact: true,
        sidebar: 'header_navigation.mon_espace',
        main: DashboardProfileContainer,
        private: true,
    },
    {
        path: "/dashboard/events",
        exact: true,
        sidebar: 'header_navigation.mes_evenements',
        main: DashboardEventsContainer,
        private: true,
    },
    {
        path: "/dashboard/schools",
        exact: true,
        sidebar: 'header_navigation.mes_ecoles',
        main: DashboardSchoolsContainer,
        private: true,
    },
    {
        path: "/dashboard/schools/:slug",
        exact: true,
        sidebar: 'header_navigation.mes_ecoles',
        main: DashboardSchoolDetailsContainer
    },
    {
        path: "/inscription/confirmation/:key([0-9a-f]{40})/:user([0-9]{1,6})",
        exact: true,
        sidebar: () => <span>Menu</span>,
        main: ConfirmEmailAddressContainer,
    },
    {
        path: "/reset_password/:key([0-9a-zA-Z]{20})/:user([0-9]{1,6})",
        exact: true,
        sidebar: () => <span>Menu</span>,
        main: SetNewPasswordContainer,
    },
    {
        path: "/",
        exact: true,
        sidebar: () => <span>Menu</span>,
        main: Home
    },
    {
        sidebar: () => <span>Menu</span>,
        main: ErrorNotFound
    }
];

const routes = [...routesFr, ...routesEn, ...routesGlobal];

export default routes;


// WEBPACK FOOTER //
// ./src/app/router/routes.js